import { render } from "./CaseIncident.vue?vue&type=template&id=4091f276"
import script from "./CaseIncident.vue?vue&type=script&lang=js"
export * from "./CaseIncident.vue?vue&type=script&lang=js"
script.render = render

export default script